import React from 'react';

import cx from 'classnames';

import { ButtonNew as Button } from '@/widgets';
import { CrossIcon, BusinessLogo } from '@/assets/icons';
import { TEST_IDS, textConstant } from '@/constants';

import ProductActivationStepper from './productActivationStepper/ProductActivationStepper';
import { IProductActivation } from './ProductActivation.types';
import styles from './ProductActivation.module.scss';

const { PREVIOUS, NEXT } = textConstant;
const { ACTIVATION_NEXT_BUTTON, ACTIVATION_PREVIOUS_BUTTON } =
	TEST_IDS.OM_ONBOARDING;

const ProductActivation = ({
	onClose,
	stepperData,
	children,
	previousHandler,
	nextHandler,
	disablePreviousButton,
	disableNextButton,
	displayFullScreen,
	displayFullWidthContent,
	nextButtonText = NEXT,
	prevButtonText = PREVIOUS,
	hideFooter,
	hidePreviousBtn = false,
	displayFullContent = false,
	...rest
}: IProductActivation) => {
	return (
		<div className={styles.productActivationContainer}>
			{!(displayFullWidthContent || displayFullScreen) && (
				<div className={styles.stepperContainer}>
					<ProductActivationStepper {...rest} steps={stepperData} />
				</div>
			)}
			{displayFullContent && !displayFullScreen ? (
				<div className={styles.rhsContainer}>
					<div className={styles.headerContainer}>
						<CrossIcon
							aria-label="cross-icon"
							onClick={onClose}
							className={styles.crossIcon}
						/>
					</div>
					{children}
				</div>
			) : (
				<div
					className={cx(styles.rhsContainer, {
						[styles.enableFullWidthContent]:
							displayFullWidthContent || displayFullScreen,
					})}
				>
					<div className={styles.headerContainer}>
						<CrossIcon
							onClick={onClose}
							aria-label="cross-icon"
							className={styles.crossIcon}
						/>
						<BusinessLogo className={styles.businessLogo} />
					</div>
					<div
						id="pgActivationContentContainer"
						className={cx(styles.contentInfoContainer, {
							[styles.enableFullScreen]: displayFullScreen,
						})}
					>
						<div className={styles.mainContentContainer}>{children}</div>
					</div>
					{!hideFooter && (
						<div
							className={cx(styles.footer, {
								[styles.alignItemsRight]: hidePreviousBtn,
							})}
						>
							{!hidePreviousBtn && (
								<Button
									disabled={disablePreviousButton}
									onClick={previousHandler}
									data-id={ACTIVATION_PREVIOUS_BUTTON}
								>
									{prevButtonText}
								</Button>
							)}
							<Button
								disabled={disableNextButton}
								variant="primary"
								onClick={nextHandler}
								data-id={ACTIVATION_NEXT_BUTTON}
							>
								{nextButtonText}
							</Button>
						</div>
					)}
				</div>
			)}
		</div>
	);
};

export default ProductActivation;
